import _asyncToGenerator from "D:/workBag/projectDemo/vuedemo10/xmmanagement/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-5c6e7408"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "top-box",
  style: {
    "margin-bottom": "1em"
  }
};
var _hoisted_2 = {
  style: {
    "margin": "15px 0 10px 0",
    "display": "flex"
  }
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h4", null, "相机", -1);
});

var _hoisted_4 = {
  class: "ver",
  style: {
    "margin-left": "10px"
  }
};
var _hoisted_5 = {
  class: "grid-content ep-bg-purple"
};
var _hoisted_6 = {
  class: "grid-content ep-bg-purple-light"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h4", {
    style: {
      "margin-bottom": "1em"
    }
  }, "升级发布规则设置", -1);
});

var _hoisted_8 = {
  style: {
    "float": "left",
    "font-size": "15px"
  }
};
var _hoisted_9 = {
  style: {
    "float": "left",
    "display": "block",
    "position": "absolute",
    "margin-top": "18px",
    "color": "#606266",
    "font-size": "10px"
  }
};
var _hoisted_10 = {
  style: {
    "display": "flex",
    "justify-content": "center"
  }
};
var _hoisted_11 = {
  style: {
    "text-align": "center"
  }
};

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "当前可升级的设备总数", -1);
});

var _hoisted_13 = {
  style: {
    "font-weight": "bolder",
    "font-size": "2em"
  }
};

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "上次更新时间", -1);
});

var _hoisted_15 = {
  style: {
    "font-weight": "400",
    "font-size": "1em"
  }
};

var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h4", {
    style: {
      "margin": "1em 0"
    }
  }, "升级发布核心数据", -1);
});

var _hoisted_17 = {
  class: "grid-icon ep-bg-purple"
};
var _hoisted_18 = {
  class: "div-weight"
};
var _hoisted_19 = {
  class: "grid-icon ep-bg-purple-light"
};

var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "div-weight"
  }, "0", -1);
});

var _hoisted_21 = {
  class: "grid-icon ep-bg-purple"
};

var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "grid-content div-weight ep-bg-purple"
  }, "0", -1);
});

var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "grid-content div-distance ep-bg-purple-light"
  }, " 占比 ", -1);
});

var _hoisted_24 = {
  class: "grid-icon ep-bg-purple-light"
};

var _hoisted_25 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "grid-content div-weight ep-bg-purple"
  }, "0", -1);
});

var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "grid-content div-distance ep-bg-purple-light"
  }, " 占比 ", -1);
});

var _hoisted_27 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h4", {
    style: {
      "margin": "1em 0"
    }
  }, "数据分析", -1);
});

import { onMounted, reactive, ref, toRefs } from 'vue';
import { QuestionFilled } from '@element-plus/icons-vue';
import { getUploadDeviceNumber, addUpgradeReleaseRules, getUpgradeReleaseRules } from '@/api/xmManagement/file/file';
import { parseTime } from '../../utils';
import router from '../../router';
import { ElMessage } from 'element-plus/lib/components';
export default {
  __name: 'upgradeRules',
  setup: function setup(__props) {
    var productInfo = ref({
      product: undefined,
      ota_type: undefined,
      version: undefined
    });
    var release = ref({
      mode: [{
        name: '全量发布',
        value: 1
      }, {
        name: '灰度发布',
        value: 2
      }]
    });
    var formRef = ref();
    var data = reactive({
      isshow: true,
      // 全量发布or灰度发布显隐控制器
      deviceUpNumber: {
        count: undefined // 可升级设备数

      },
      uploadTime: undefined,
      // 上一次更新时间
      issue: [// 灰度发布下拉选择器option属性
      {
        name: '按比例灰度',
        desc: '按照设备总数比例发布,当比例为100%时视为全量发布',
        value: 1
      }, {
        name: '按数量灰度',
        desc: '按照设备总数数量发布, 当数量为可升级设备最大值的时候视为全量发布',
        value: 2
      }],
      maxIssueValue: undefined,
      // 灰度发布滑动条最大值
      buttonType: 'info',
      // 发布提交按钮样式类型
      buttonDisabled: true,
      // 发布提交按钮是否可点击
      buttonText: '提交',
      // 发布提交按钮文本
      issueTypeText: undefined,
      // 灰度发布说明文本,
      form: {
        method: 2,
        // 发布方式
        gray: undefined,
        // 1：百分比灰度，2：数量灰度发布
        total: 0,
        // 灰度发布滑动条的值
        product: undefined,
        ota_type: undefined,
        version: undefined
      }
    });

    var _toRefs = toRefs(data),
        isshow = _toRefs.isshow,
        deviceUpNumber = _toRefs.deviceUpNumber,
        uploadTime = _toRefs.uploadTime,
        issue = _toRefs.issue,
        maxIssueValue = _toRefs.maxIssueValue,
        buttonType = _toRefs.buttonType,
        buttonDisabled = _toRefs.buttonDisabled,
        buttonText = _toRefs.buttonText,
        issueTypeText = _toRefs.issueTypeText,
        form = _toRefs.form; // 获取灰度发布选择事件说明文本


    var forIssueGetDesc = function forIssueGetDesc(issue_type) {
      issue.value.forEach(function (item) {
        if (item.value === issue_type) {
          issueTypeText.value = item.desc;
        }
      });
    };

    var selMode = function selMode(item) {
      if (form.value.method == 2) {
        isshow.value = true;
      } else {
        isshow.value = false;
      }
    }; // 灰度发布类型选择事件


    var issueTypeChange = function issueTypeChange(item) {
      if (item === 1) {
        maxIssueValue.value = 100;
      } else {
        maxIssueValue.value = deviceUpNumber.value.count;
      }

      issueInputChange(form.value.total);
      forIssueGetDesc(item);
    };

    var issueButtonStatu1 = function issueButtonStatu1() {
      buttonText.value = '全量发布';
      buttonType.value = 'primary';
      buttonDisabled.value = false;
    };

    var issueButtonStatu2 = function issueButtonStatu2() {
      buttonText.value = '提交';
      buttonType.value = 'info';
      buttonDisabled.value = true;
    };

    var issueButtonStatu3 = function issueButtonStatu3() {
      buttonText.value = '提交';
      buttonType.value = 'primary';
      buttonDisabled.value = false;
    }; // 灰度滑条滑动事件 || 回显


    var issueInputChange = function issueInputChange(item) {
      switch (form.value.gray) {
        case 1:
          if (item === 100) {
            issueButtonStatu1();
          } else if (item === 0) {
            issueButtonStatu2();
          } else {
            issueButtonStatu3();
          }

          break;

        case 2:
          if (item === deviceUpNumber.value.count) {
            issueButtonStatu1();
          } else if (item === 0) {
            issueButtonStatu2();
          } else {
            issueButtonStatu3();
          }

          break;
      }
    }; // 获取设备升级总数


    var getUploadDsNumber = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(item) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getUploadDeviceNumber(item).then(function (res) {
                  deviceUpNumber.value = res;
                  uploadTime.value = parseTime(new Date().getTime());
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getUploadDsNumber(_x) {
        return _ref.apply(this, arguments);
      };
    }(); // 提交请求


    var submitIssueTs = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return addUpgradeReleaseRules(form.value).then(function (res) {
                  ElMessage.success('添加成功');
                  resetFormData();
                }).catch(function () {
                  ElMessage.error('添加失败');
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function submitIssueTs() {
        return _ref2.apply(this, arguments);
      };
    }(); // 提交按钮事件


    var submitIssue = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                submitIssueTs();

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function submitIssue() {
        return _ref3.apply(this, arguments);
      };
    }(); // 重置表单参数


    var resetFormData = function resetFormData() {
      formRef.value.resetFields();
    }; // 全量发布


    var allSubmitIssue = function allSubmitIssue() {
      form.value.method = 1;
      form.value.total = 0;
      form.value.gray = 0;
      submitIssueTs();
    }; // 获取发布规则


    var getIssueRules = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return getUpgradeReleaseRules(productInfo.value);

              case 2:
                form.value = _context4.sent;
                issueInputChange(form.value.total);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function getIssueRules() {
        return _ref4.apply(this, arguments);
      };
    }();

    onMounted(function () {
      productInfo.value = router.currentRoute.value.query;
      form.value.product = productInfo.value.product;
      form.value.ota_type = productInfo.value.ota_type;
      form.value.version = productInfo.value.version;
      getUploadDsNumber(productInfo.value);
      getIssueRules();
    });
    return function (_ctx, _cache) {
      var _component_el_tag = _resolveComponent("el-tag");

      var _component_el_col = _resolveComponent("el-col");

      var _component_el_row = _resolveComponent("el-row");

      var _component_el_option = _resolveComponent("el-option");

      var _component_el_select = _resolveComponent("el-select");

      var _component_el_form_item = _resolveComponent("el-form-item");

      var _component_el_slider = _resolveComponent("el-slider");

      var _component_el_button = _resolveComponent("el-button");

      var _component_el_form = _resolveComponent("el-form");

      var _component_el_card = _resolveComponent("el-card");

      var _component_el_icon = _resolveComponent("el-icon");

      var _component_el_tooltip = _resolveComponent("el-tooltip");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_card, {
        class: "box-card",
        style: {
          "position": "relative"
        }
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_tag, {
            class: "mx-1",
            effect: "plain",
            round: "",
            type: "success"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("固件版本: " + _toDisplayString(productInfo.value.version), 1)];
            }),
            _: 1
          })])]), _createVNode(_component_el_row, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_col, {
                span: 4
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_5, " 固件类型: " + _toDisplayString(productInfo.value.ota_type), 1)];
                }),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 8
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_6, " 所属产品: " + _toDisplayString(productInfo.value.product), 1)];
                }),
                _: 1
              })];
            }),
            _: 1
          })]), _createVNode(_component_el_card, null, {
            default: _withCtx(function () {
              return [_hoisted_7, _createVNode(_component_el_form, {
                model: _unref(form),
                "label-position": _ctx.labelPosition,
                "label-width": "100px",
                ref_key: "formRef",
                ref: formRef
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_row, {
                    gutter: 15
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_col, {
                        span: 14
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            label: "发布方式:",
                            prop: "method"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_select, {
                                onChange: selMode,
                                modelValue: _unref(form).method,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                                  return _unref(form).method = $event;
                                }),
                                placeholder: "请选择",
                                size: "200px"
                              }, {
                                default: _withCtx(function () {
                                  return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(release.value.mode, function (item, index) {
                                    return _openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: item.name,
                                      value: item.value
                                    }, null, 8, ["label", "value"]);
                                  }), 128))];
                                }),
                                _: 1
                              }, 8, ["modelValue"]), _withDirectives(_createElementVNode("div", null, " 默认灰度范围为当前可升级设备总数，表示可以控制发布的最大数量 ", 512), [[_vShow, _unref(isshow)]]), _withDirectives(_createElementVNode("div", null, " 发布后，所有设备〔指当前已激活或未来新激活，低于此固件版本且支持OTA的设备)将接收升级任务推送 ", 512), [[_vShow, !_unref(isshow)]])];
                            }),
                            _: 1
                          }), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_form_item, {
                            label: "灰度设置方式:",
                            prop: "gray"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_select, {
                                placeholder: "请选择",
                                modelValue: _unref(form).gray,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                                  return _unref(form).gray = $event;
                                }),
                                onChange: issueTypeChange
                              }, {
                                default: _withCtx(function () {
                                  return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(issue), function (item, index) {
                                    return _openBlock(), _createBlock(_component_el_option, {
                                      style: {
                                        "height": "50px"
                                      },
                                      key: index,
                                      label: item.name,
                                      value: item.value
                                    }, {
                                      default: _withCtx(function () {
                                        return [_createElementVNode("span", _hoisted_8, _toDisplayString(item.name), 1), _createElementVNode("span", _hoisted_9, _toDisplayString(item.desc), 1)];
                                      }),
                                      _: 2
                                    }, 1032, ["label", "value"]);
                                  }), 128))];
                                }),
                                _: 1
                              }, 8, ["modelValue"]), _createElementVNode("div", null, _toDisplayString(_unref(issueTypeText)), 1)];
                            }),
                            _: 1
                          }), _createVNode(_component_el_form_item, {
                            label: "升级设备数:",
                            class: "a",
                            prop: "total"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_slider, {
                                max: _unref(maxIssueValue),
                                modelValue: _unref(form).total,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                                  return _unref(form).total = $event;
                                }),
                                onInput: issueInputChange,
                                "show-input": "",
                                "show-input-controls": false
                              }, null, 8, ["max", "modelValue"])];
                            }),
                            _: 1
                          }), _createVNode(_component_el_form_item, null, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_button, {
                                type: _unref(buttonType),
                                disabled: _unref(buttonDisabled),
                                onClick: submitIssue
                              }, {
                                default: _withCtx(function () {
                                  return [_createTextVNode(_toDisplayString(_unref(buttonText)), 1)];
                                }),
                                _: 1
                              }, 8, ["type", "disabled"])];
                            }),
                            _: 1
                          })], 512), [[_vShow, _unref(isshow)]]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_form_item, null, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_button, {
                                type: "primary",
                                onClick: allSubmitIssue
                              }, {
                                default: _withCtx(function () {
                                  return [_createTextVNode("全量发布")];
                                }),
                                _: 1
                              })];
                            }),
                            _: 1
                          })], 512), [[_vShow, !_unref(isshow)]])];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 10
                      }, {
                        default: _withCtx(function () {
                          return [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(deviceUpNumber).count), 1), _hoisted_14, _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(uploadTime)), 1)])])];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }, 8, ["model", "label-position"])];
            }),
            _: 1
          }), _hoisted_16, _createVNode(_component_el_row, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_col, {
                span: 6
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_17, [_createTextVNode(" 可升级设备总数 "), _createVNode(_component_el_tooltip, {
                    content: "1",
                    placement: "top-start"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_icon, {
                        class: "el-icon--right"
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_unref(QuestionFilled))];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  })]), _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(deviceUpNumber).count), 1)];
                }),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 6
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_19, [_createTextVNode(" 指定升级设备数 "), _createVNode(_component_el_tooltip, {
                    content: "1",
                    placement: "top-start"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_icon, {
                        class: "el-icon--right"
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_unref(QuestionFilled))];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  })]), _hoisted_20];
                }),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 6
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_21, [_createTextVNode(" 升级触发设备数 "), _createVNode(_component_el_tooltip, {
                    content: "1",
                    placement: "top-start"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_icon, {
                        class: "el-icon--right"
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_unref(QuestionFilled))];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  })]), _createVNode(_component_el_row, null, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_col, {
                        span: 2
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_22];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 22
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_23];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 6
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_24, [_createTextVNode(" 升级成功设备数 "), _createVNode(_component_el_tooltip, {
                    content: "1",
                    placement: "top-start"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_icon, {
                        class: "el-icon--right"
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_unref(QuestionFilled))];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  })]), _createVNode(_component_el_row, null, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_col, {
                        span: 2
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_25];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 22
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_26];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _hoisted_27, _createVNode(_component_el_row, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_button, {
                    type: "primary",
                    plain: ""
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode("升级状态分布")];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_button, {
                    type: "primary",
                    plain: ""
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode("升级次数分布")];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      })]);
    };
  }
};